<template>
  <div class="recomendation-letters">
    <div class="centered">
        <router-link :to="{ name: 'RecommendationLetterCreator' }" class="button centered">
          Добавить рекомендательное письмо
        </router-link>
      </div>
    <draggable class="columns is-multiline mt-10 letters-columns" v-model="recommendationLettersObject">
      <RecommendationLetterItem 
        v-for="letter in recommendationLetters" 
        :key="letter.id" 
        :letter="letter"
        class="column is-one-third"
      />
    </draggable>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import draggable from 'vuedraggable'
import deepcopy from 'deepcopy'
import RecommendationLetterItem from 'components/BrandHistory/RecommendationLetterItem'

export default {
  name: 'RecommendationLetters',
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['recommendationLetters']),
    recommendationLettersObject: {
      get () { return deepcopy(this.recommendationLetters) },
      set (value) {
        const valueCopy = deepcopy(value)
        for (let i = 0; i < valueCopy.length; i++) {
          valueCopy[i].order = i
        }
        this.updateRecommendationLettersOrder(valueCopy)
      }
    }
  },
  methods: {
    ...mapActions(['getRecommendationLetters', 'updateRecommendationLettersOrder'])
  },
  created () {
    this.getRecommendationLetters()
  },
  components: { RecommendationLetterItem, draggable }
}
</script>
<style>
.reviews-columns {
  max-width: 1280px;
  margin: 0 auto !important;
}
</style>



// WEBPACK FOOTER //
// RecommendationLetters.vue?086f62b6